var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgSubs = function SvgSvgSubs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.511 1.666a2 2 0 0 1 2.98 0l.7.782a2 2 0 0 0 1.601.663l1.05-.058A2 2 0 0 1 16.95 5.16l-.058 1.049a2 2 0 0 0 .663 1.6l.782.7a2 2 0 0 1 0 2.98l-.782.7a2 2 0 0 0-.663 1.602l.058 1.05a2 2 0 0 1-2.108 2.107l-1.049-.058a2 2 0 0 0-1.6.663l-.7.782a2 2 0 0 1-2.98 0l-.7-.782a2 2 0 0 0-1.602-.663l-1.05.058a2 2 0 0 1-2.107-2.108l.058-1.05a2 2 0 0 0-.663-1.6l-.782-.7a2 2 0 0 1 0-2.98l.782-.7a2 2 0 0 0 .663-1.601l-.058-1.05a2 2 0 0 1 2.108-2.106l1.05.058a2 2 0 0 0 1.6-.663l.7-.782v-.001Z",
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.501 7.5h.01v.01h-.01V7.5Zm5 5h.01v.01h-.01v-.01Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.002 7-6 6",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSvgSubs;